// The 8 Fragments = roguelite ability pool. Each entry is pure data; the
// logic lives in src/game/fragments.js, which reads `hooks` and applies them.
// Keep this file clean and declarative so re-balancing is trivial.

export const FRAGMENTS = [
  {
    id: 'reapers_mark',
    name: "Reaper's Mark",
    kind: 'SUSTAIN',
    desc: "Kills have a 25% chance to restore 1 HP.",
    color: 0xff4060,
  },
  {
    id: 'ricochet',
    name: 'Ricochet Rounds',
    kind: 'OFFENSE',
    desc: "Bullets bounce once to a nearby enemy within 6m.",
    color: 0xffcc44,
  },
  {
    id: 'phantom_step',
    name: 'Phantom Step',
    kind: 'MOBILITY',
    desc: "Dash cooldown -50%. Dash i-frames +50%.",
    color: 0x8afff0,
  },
  {
    id: 'void_shroud',
    name: 'Void Shroud',
    kind: 'STEALTH',
    desc: "Stand still 1s to cloak. First shot out of cloak crits (3x dmg).",
    color: 0x9a6aff,
  },
  {
    id: 'echo_shot',
    name: 'Echo Shot',
    kind: 'AOE',
    desc: "Every 3rd shot also fires a slow 360-degree ghost ring.",
    color: 0x70e0ff,
  },
  {
    id: 'fracture_core',
    name: 'Fracture Core',
    kind: 'AOE',
    desc: "20% of kills drop an explosive shard (2m radius, 2 dmg).",
    color: 0xff7a33,
  },
  {
    id: 'adrenal_lock',
    name: 'Adrenal Lock',
    kind: 'DEFENSE',
    desc: "Taking damage slows time to 60% for 0.6s (for you only).",
    color: 0x50ff88,
  },
  {
    id: 'null_overdrive',
    name: 'Null Overdrive',
    kind: 'BERSERK',
    desc: "Below 25% HP: +40% fire rate, +20% move speed.",
    color: 0xff3080,
  },
];

export function getFragmentById(id) {
  return FRAGMENTS.find((f) => f.id === id) || null;
}
